/** Malawian MSCE numeric grades (1–9) from percentage marks (0–100). */

export type MsceScaleRow = {
  grade: number;
  min: number;
  max: number;
  remark: string;
};

export const MSCE_SCALE: MsceScaleRow[] = [
  { grade: 1, min: 80, max: 100, remark: 'Distinction' },
  { grade: 2, min: 70, max: 79, remark: 'Distinction' },
  { grade: 3, min: 65, max: 69, remark: 'Credit' },
  { grade: 4, min: 60, max: 64, remark: 'Credit' },
  { grade: 5, min: 55, max: 59, remark: 'Credit' },
  { grade: 6, min: 50, max: 54, remark: 'Credit' },
  { grade: 7, min: 45, max: 49, remark: 'Pass' },
  { grade: 8, min: 40, max: 44, remark: 'Pass' },
  { grade: 9, min: 0, max: 39, remark: 'Fail' },
];

export function getGrade(marks: number): number {
  const m = Math.max(0, Math.min(100, marks));
  if (m >= 80) return 1;
  if (m >= 70) return 2;
  if (m >= 65) return 3;
  if (m >= 60) return 4;
  if (m >= 55) return 5;
  if (m >= 50) return 6;
  if (m >= 45) return 7;
  if (m >= 40) return 8;
  return 9;
}

export function getRemark(grade: number): string {
  const row = MSCE_SCALE.find((r) => r.grade === grade);
  return row?.remark ?? 'Fail';
}

export function getGradeFromMarks(marks: number): { grade: number; remark: string } {
  const grade = getGrade(marks);
  return { grade, remark: getRemark(grade) };
}

export function formatGradeDisplay(grade: number, remark: string): string {
  return `Grade ${grade} — ${remark}`;
}

/** UI color by MSCE grade (1 = best). */
export function getMsceGradeColor(grade: number): string {
  if (grade <= 2) return '#28a745';
  if (grade <= 6) return '#17a2b8';
  if (grade <= 8) return '#ffc107';
  return '#dc3545';
}

export function getMsceColorFromMarks(marks: number): string {
  return getMsceGradeColor(getGrade(marks));
}
